import { useMutation } from '@tanstack/react-query'
import { useToast } from 'src/shared/hooks/use-toast'

import { ServerRoutes } from './serverRoutes'

interface AcceptAdminInviteProps {
  first_name?: string
  last_name?: string
  email?: string
  organization_id: string
  user_id: string
  bring_current_orders?: boolean
}

export const useAcceptAdminInvite = () => {
  const toast = useToast()

  return useMutation({
    mutationFn: async (props: AcceptAdminInviteProps) => {
      const response = await fetch(
        import.meta.env.VITE_BE_SERVER_URL + ServerRoutes.acceptAdminInvite,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: props.first_name,
            last_name: props.last_name,
            email: props.email,
            organization_id: props.organization_id,
            user_id: props.user_id,
            bring_current_orders: props.bring_current_orders ?? false,
          }),
        }
      )

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.msg || 'Failed to accept admin invite')
      }

      return response
    },
    onError: (error: Error) => {
      toast.toast({
        title: 'Something went wrong',
        description: error.message,
        variant: 'destructive',
        duration: 5000,
      })
    },
  })
}
